module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span tabindex="0" class=\'phx-cell-revert-action ui-icon ui-icon-arrowrefresh-1-s\' style="display:inline-block; padding:0; margin:0"></span>';
}
return __p;
};
